import { render, staticRenderFns } from "./ChartjsBarChart.vue?vue&type=template&id=8a28e8ae&"
import script from "./ChartjsBarChart.vue?vue&type=script&lang=js&"
export * from "./ChartjsBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports